import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, X } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { path: '/', label: t('nav.home') },
    { path: '/chi-sono', label: t('nav.chiSono') },
    { path: '/perche-un-accompagnatore', label: t('nav.percheAccompagnatore') },
    { path: '/prove-di-fedelta', label: t('nav.proveFedelta') },
    { path: '/servizi-offerti', label: t('nav.serviziOfferti') },
    { path: '/servizi-di-lusso', label: t('nav.serviziLusso') },
    { path: '/gallery', label: t('nav.gallery') },
    { path: '/contatti', label: t('nav.contatti') },
  ];

  return (
    <>
      <div className="top-bar" />
      <header className="header">
        <nav className="nav-container">
          <button
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={location.pathname === item.path ? 'active' : ''}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <LanguageSwitcher />
        </nav>
      </header>
    </>
  );
};

export default Header;
